import { toTitleCase } from "@/utils";
import Heading from "../Badge/Heading";
import FaBook from "../SVG/Fontawesome/FaBook";
import UpdatedAt from "../UpdatedAt";

const Answer = (props: any) => {
  const { subjectName, headingText, questionClass, ocrText, typeOfSolution } = props;
  const descriptionText = `Step by step ${typeOfSolution} solution for ${ocrText
    .replace(new RegExp("[`]", "g"), "")
    .replace(new RegExp("<img[^>]*>|<br[^>]*>", "g"), "")
    .trim()
  } by ${toTitleCase(subjectName)} experts to help you in doubts & scoring excellent marks in Class ${questionClass} exams.`

  return (
    <section id="answer-container" className="flex flex-col justify-center w-full">
      <div className="card sm:!px-6 rounded-2xl bg-secondary ">
        <div className="flex items-center justify-between">
          <Heading headingText={headingText} icon={<FaBook />} />
        </div>
        <p id="video-answer-text" className="w-full font-normal overflow-x-hidden overflow-y-auto mt-2 ease-[0.5s]">
          {descriptionText}
        </p>
        <UpdatedAt updatedOn={props.updatedAt} />
      </div>
    </section>
  );
}

export default Answer;